/* ms4l-eta.js — единый источник сроков доставки. 13.08.2026.
 *
 * Один расчёт на весь сайт: карточка товара, выдвижная корзина, страница корзины.
 * Состояние лежит в window.__MS4L_ETA, об изменениях сообщает событие 'ms4l:eta'.
 * Тот же приём, что у bulk-progress.js — чтобы блоки физически не могли разойтись.
 *
 * ЧТО ПОКАЗЫВАЕМ
 * Клиенту видна ОДНА дата — диапазон отпугивает. Это РАННЯЯ оценка, поэтому и
 * формулировка соответствующая: «Get it as soon as Mon, Aug 17», как у Best Buy.
 * «As soon as» — это не обещание прибытия, а нижняя граница, и вместе с
 * дисклеймером Алехандро закрывает вопрос гарантий.
 *
 * Диапазон остаётся в состоянии (from/to, daysLo/daysHi): нужен для отладки и на
 * случай, если решат вернуть в интерфейс. Переключатель — SHOW_RANGE.
 *
 * Для фрахта даты нет вообще: перевозчик звонит согласовать время, и придумывать
 * за него дату нельзя. Именно с этого началось письмо Алехандро 11.08 — клиенты
 * записывали монтажников на показанную дату и требовали компенсировать выезд.
 *
 * ОТКУДА ЦИФРЫ
 * Зоны — с карты на /pages/shipping-delivery-policy, той самой, что видит
 * клиент: 1–2, 2–3, 3–4, 4–6 рабочих дней транзита от ближайшего склада
 * (Флорида, Техас, Калифорния). Модуль и страница обязаны говорить одно и то же,
 * иначе покупатель поймает нас на расхождении.
 * Обработка заказа — 1 рабочий день, оттуда же: «shipped usually within one to
 * two business days», нижняя граница.
 *
 * Итого до двери: Z1 = 2 раб. дня, Z2 = 3, Z3 = 4, Z4 = 5.
 * Для Майами это 2 дня — что и соответствует фактической доставке за 2–3 дня.
 */
(function () {
  'use strict';
  // Файл подключают и карточка, и корзина — второй раз отрабатывать не нужно.
  if (window.MS4L_ETA) return;

  var HANDLING = [1, 2];            // рабочих дней до передачи перевозчику
  var SHOW_RANGE = false;           // true — вернуть диапазон вместо одной даты

  // Зоны — 1:1 с картой на странице политики доставки. Цвета там же:
  // зелёная 1–2, жёлтая 2–3, фиолетовая 3–4, голубая 4–6 рабочих дней.
  // Границы ZIP3 — стандартные диапазоны штатов.
  // ZIP3 читаем как число: "010" -> 10, поэтому ведущие нули в литералах не пишем.
  // [5,5] — это 005, Холтсвилл, штат Нью-Йорк: единственный ZIP3 ниже 010.
  var ZONES = {
    // зелёная: рядом со складами во Флориде и Техасе. CA/AZ/NV/NM — в жёлтой с 28.10.2026 (Jenny: в CA за 2 дня не доезжает)
    z1: { days: [1, 2], label: 'Zone 1', color: '#8fbf8f', ranges: [
      [300, 319], [398, 399],                    // GA
      [320, 349],                                // FL
      [350, 369],                                // AL
      [386, 397],                                // MS
      [700, 714],                                // LA
      [730, 749],                                // OK
      [750, 799], [885, 885] ] },                // TX
    // жёлтая
    z2: { days: [2, 3], label: 'Zone 2', color: '#f4d03f', ranges: [
      [270, 289],                                // NC
      [290, 299],                                // SC
      [370, 385],                                // TN
      [400, 427],                                // KY
      [716, 729],                                // AR
      [630, 658],                                // MO
      [660, 679],                                // KS
      [800, 816],                                // CO
      [840, 847],                                // UT
      [832, 838],                                // ID
      [970, 979],                                // OR
      [850, 865],                                // AZ
      [870, 884],                                // NM
      [889, 898],                                // NV
      [900, 961] ] },                            // CA
    // фиолетовая: северо-восток и часть Среднего Запада
    z3: { days: [3, 4], label: 'Zone 3', color: '#c8a2d8', ranges: [
      [5, 5], [100, 149],                        // NY
      [10, 27],                                  // MA
      [28, 29],                                  // RI
      [30, 38],                                  // NH
      [39, 49],                                  // ME
      [50, 59],                                  // VT
      [60, 69],                                  // CT
      [70, 89],                                  // NJ
      [150, 196],                                // PA
      [197, 199],                                // DE
      [200, 205],                                // DC
      [206, 219],                                // MD
      [220, 246],                                // VA
      [247, 268],                                // WV
      [430, 459],                                // OH
      [460, 479],                                // IN
      [600, 629],                                // IL
      [500, 528],                                // IA
      [680, 693],                                // NE
      [570, 577] ] },                            // SD
    // голубая: север и северо-запад
    z4: { days: [4, 6], label: 'Zone 4', color: '#a8d4f0', ranges: [
      [480, 499],                                // MI
      [530, 549],                                // WI
      [550, 567],                                // MN
      [580, 588],                                // ND
      [590, 599],                                // MT
      [820, 831],                                // WY
      [980, 994] ] }                             // WA  (AK/HI с 23.10.2026 — offshore, не доставляем)
  };

  var FREIGHT_TYPES = ['Ceiling Cassette', 'Concealed Duct', 'Universal Floor/Ceiling',
    'PTAC/PTHP', 'Mini Floor Console', 'Multi Position', 'Multi Position Air Handler',
    'Outdoor Unit', 'One-Way Cassette', 'Portable AC'];
  var PARCEL_TYPES = ['TTW', 'indoor unit', 'Air Handler', 'HVAC Part', 'Accessories',
    'HVAC Accessories', 'Air Filter', 'Humidity Control'];
  // 27.10.2026: запчасти (профиль доставки «HVAC Parts») возим и на Аляску с Гавайями — FedEx, цена в чекауте
  var PART_TYPES = ['PCBs', 'Compressors', 'Fan Motors', 'Fan Blowers', 'Other Parts', 'HVAC Part'];
  function akhi(zip) { var p = parseInt(String(zip).slice(0, 3), 10); return (p >= 995 && p <= 999) || p === 967 || p === 968; }

  var KEY = 'ms4l_zip';

  /* ---------- замер ----------
   * Тот же приём, что у AI-подсказок в карточке: gtag с send_to. Отличие в
   * очереди: наш скрипт стартует раньше gtag, и без неё событие показа терялось
   * молча — ровно та ошибка, которую уже ловили на bulk-баре.
   */
  var GA = 'G-8B9BH0BS0B';
  var q = [];
  function flush() {
    if (typeof gtag !== 'function') return false;
    while (q.length) { var e = q.shift(); try { gtag('event', e[0], e[1]); } catch (x) {} }
    return true;
  }
  function track(name, p) {
    p = p || {};
    p.send_to = GA;
    p.transport_type = 'beacon';
    q.push([name, p]);
    flush();
    /* 20.10.2026: the same events go to Microsoft Clarity, which is already on the page (no extra file or request),
       so recordings can be filtered by them; sessions that open or use pickup are kept for full playback. */
    try {
      var c = window.clarity;
      if (typeof c === 'function') {
        c('event', name);
        if (p.method) c('set', 'ms4l_method', String(p.method));
        if (p.store) c('set', 'ms4l_pickup_store', String(p.store));
        if (p.theme === 'test') c('set', 'ms4l_theme', 'test');
        if (name === 'eta_geo_result') c('set', 'ms4l_geo_result', String(p.result));   // 23.10.2026
        if (name === 'eta_pickup_open' || name === 'eta_pickup_add') c('upgrade', name);
      }
    } catch (e) {}
  }
  var tries = 0;
  var flushTimer = setInterval(function () {
    if (flush() || ++tries > 40) clearInterval(flushTimer);   // ждём gtag до 20 секунд
  }, 500);

  /* ---------- ZIP ---------- */
  function readZip() {
    try { return (localStorage.getItem(KEY) || '').replace(/\D/g, '').slice(0, 5); }
    catch (e) { return ''; }
  }
  function saveZip(z) {
    try { localStorage.setItem(KEY, z); } catch (e) {}
  }
  // Атрибуты корзины — главный измеритель. Событие в GA4 живёт в сессии и
  // отваливается вместе с согласием на куки, а атрибут приезжает в заказ и лежит
  // там навсегда: по нему видно и долю заказов, сделанных с модулем, и какой
  // срок мы человеку показали, когда он покупал. Второе ещё и снимает спор в
  // поддержке — у Алехандро это как раз про вызванных монтажников.
  function saveCartAttrs(e) {
    if (!e || !e.zip) return;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: {
        'Delivery ZIP': e.zip,
        'Delivery ETA': e.ok ? (e.mode === 'freight' ? e.text + ' (freight, by appointment)' : e.text) : ''
      } })
    }).catch(function () {});
  }
  // Куда магазин не возит: Пуэрто-Рико и Виргинские острова (006–009), Гуам и
  // Микронезия (969). Это не «неизвестный ZIP», а отдельный ответ — иначе модуль
  // будет бесконечно просить ввести индекс заново.
  // 23.10.2026: Аляска (995–999) и Гавайи (967–968) — не доставляем (Alejandro), как и острова
  function offshore(p) { return (p >= 6 && p <= 9) || p === 969 || (p >= 995 && p <= 999) || p === 967 || p === 968; }

  function zoneOf(zip) {
    if (!/^\d{5}$/.test(zip)) return null;
    var p = parseInt(zip.slice(0, 3), 10);
    if (offshore(p)) return 'out';
    for (var k in ZONES) {
      var r = ZONES[k].ranges;
      for (var i = 0; i < r.length; i++) if (p >= r[i][0] && p <= r[i][1]) return k;
    }
    return null;                              // ZIP вне известных диапазонов
  }

  /* ---------- время склада ---------- */
  // Отсечка в полдень — из политики: «cleared payment received by noon». Полдень
  // складской, восточный, а не браузерный: для клиента из Калифорнии 10 утра по
  // его часам — это уже 13:00 на складе, и заказ уходит следующим днём. Считали
  // по браузеру — дата для Запада была на день оптимистичнее правды.
  var TZ = 'America/New_York';
  function storeNow() {
    try { return new Date(new Date().toLocaleString('en-US', { timeZone: TZ })); }
    catch (e) { return new Date(); }
  }
  function isWorkday(d) { var w = d.getDay(); return w !== 0 && w !== 6; }

  // Сколько осталось до отсечки. Best Buy показывает такой счётчик рядом с датой —
  // он и объясняет, откуда она берётся, и подталкивает не откладывать заказ.
  function cutoff() {
    var n = storeNow();
    if (!isWorkday(n)) return { before: false };
    var noon = new Date(n.getTime());
    noon.setHours(12, 0, 0, 0);
    var ms = noon - n;
    if (ms <= 0) return { before: false };
    var h = Math.floor(ms / 3600000), m = Math.floor((ms % 3600000) / 60000);
    return { before: true, ms: ms, text: (h ? h + 'h ' : '') + m + 'm' };
  }

  /* ---------- рабочие дни ---------- */
  function addBusinessDays(from, n) {
    var d = new Date(from.getTime());
    while (n > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) n--; }
    return d;
  }
  function fmt(d) {
    return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
  }

  /* ---------- фрахт или посылка ---------- */
  function zonesInTitle(t) { var m = /(\d+)\s*-?\s*Zone/i.exec(t || ''); return m ? +m[1] : 1; }
  function btuInTitle(t) {
    var m = /(\d{1,3}(?:,\d{3})|\d{4,6})\s*BTU/i.exec(t || '');
    return m ? parseInt(m[1].replace(/,/g, ''), 10) : null;
  }
  function isFreight(type, title, qty) {
    if (PARCEL_TYPES.indexOf(type) !== -1) return false;
    if ((qty || 1) >= 2) return true;
    if (zonesInTitle(title) >= 2) return true;
    if (FREIGHT_TYPES.indexOf(type) !== -1) return true;
    var b = btuInTitle(title);
    return !!(b && b >= 13000);
  }

  /* ---------- расчёт ---------- */
  function compute(items) {
    var zip = readZip();
    var zone = zoneOf(zip);
    var freight = items.some(function (it) { return isFreight(it.type, it.title, it.qty); });
    var out = { zip: zip, zone: zone, freight: freight, ok: false };

    if (zone === 'out') {
      // 27.10.2026: одни запчасти на Аляску/Гавайи — не «не возим», а FedEx с ценой в чекауте; системы и смешанная корзина — как было
      var parts = items.length > 0 && items.every(function (it) { return PART_TYPES.indexOf(it.type) !== -1; });
      out.mode = parts && akhi(zip) ? 'parts-remote' : 'out-of-area'; out.zone = null; return out;
    }
    if (!zone) { out.mode = 'need-zip'; return out; }

    // Дата считается и для фрахта: зоны на странице политики описывают именно
    // паллетную LTL-доставку — так магазин возит почти всё. Разница не в сроке,
    // а в том, что день привоза транспортная компания согласует звонком, поэтому
    // у фрахта к дате всегда идёт приписка про согласование.

    var z = ZONES[zone];
    var now = storeNow();
    // после полудня по складу заказ уходит следующим рабочим днём
    var start = (now.getHours() >= 12 || !isWorkday(now)) ? addBusinessDays(now, 1) : now;
    var lo = addBusinessDays(start, HANDLING[0] + z.days[0]);
    var hi = addBusinessDays(start, HANDLING[1] + z.days[1]);
    out.mode = freight ? 'freight' : 'parcel';
    out.ok = true;
    out.zoneLabel = z.label;
    out.daysLo = HANDLING[0] + z.days[0];
    out.daysHi = HANDLING[1] + z.days[1];
    out.from = lo; out.to = hi;
    // Клиенту — ранняя дата, поэтому в интерфейсе она подписана «as soon as».
    out.date = lo;
    out.text = SHOW_RANGE ? (fmt(lo) + ' – ' + fmt(hi)) : fmt(lo);
    out.long = lo.toLocaleDateString('en-US',
      { weekday: 'long', month: 'long', day: 'numeric' });
    out.color = z.color;
    return out;
  }

  /* ---------- публичный API ---------- */
  var state = { items: [], eta: null };
  function recalc() {
    state.eta = compute(state.items);
    window.__MS4L_ETA = state.eta;
    document.dispatchEvent(new CustomEvent('ms4l:eta', { detail: state.eta }));
  }
  window.MS4L_ETA = {
    setItems: function (items) { state.items = items || []; recalc(); },
    setZip: function (z, source) {
      z = String(z || '').replace(/\D/g, '').slice(0, 5);
      if (z.length !== 5) { track('eta_zip_invalid', { source: source || 'manual' }); return false; }
      saveZip(z);
      recalc();
      var e = state.eta || {};
      track('eta_zip_set', {
        source: source || 'manual',
        zone: e.zoneLabel || e.mode || 'unknown',
        mode: e.mode || 'unknown'
      });
      saveCartAttrs(e);
      return true;
    },
    clearZip: function () { try { localStorage.removeItem(KEY); } catch (e) {} recalc(); },
    get: function () { return state.eta; },
    zip: readZip,
    isFreight: isFreight,
    recalc: recalc,
    // Расчёт по одной позиции, без записи в общее состояние: нужен строкам в корзине.
    forItems: function (items) { return compute(items || []); },
    cutoff: cutoff,
    track: track,
    // Подставить индекс из адреса покупателя, если сам он ещё ничего не вводил.
    seedZip: function (z) {
      if (readZip()) return false;
      z = String(z || '').replace(/\D/g, '').slice(0, 5);
      if (z.length !== 5) return false;
      saveZip(z);
      recalc();
      track('eta_zip_set', { source: 'account', zone: (state.eta || {}).zoneLabel || 'unknown',
                             mode: (state.eta || {}).mode || 'unknown' });
      saveCartAttrs(state.eta);
      return true;
    }
  };

  /* ---------- геолокация -> ZIP ----------
   * 23.10.2026 (reports/geo_oct23/): на iPhone в Firefox кнопка на всё отвечала «Couldn't find your
   * location». Теперь у каждой причины свой ответ, и ZIP находится даже без внешнего сервиса:
   *  1) браузер не дал координаты: denied (разрешение выключено), unavailable, timeout;
   *  2) онлайн-геокодер (bigdatacloud, без ключа) режут защита от трекинга и блокировщики, а бывает, что он
   *     просто думает. Ждём его 2,5 с, дальше ZIP берём без сети: ближайший центроид ZIP3 из
   *     assets/ms4l-zip3.json (US Census ZCTA, scripts/bi/build_zip3_geo.py) и ZIP5-представитель
   *     этого ZIP3 — result = fallback. Точность — уровень ZIP3 (медиана ~28 км), зона сроков совпадает в 98%;
   *  3) человек не в США — так и говорим (outside_us), а не подставляем ближайший Буффало.
   * cb(ok, result), result: ok | fallback | denied | unavailable | timeout | outside_us.
   * opt.zip3 — URL таблицы (asset_url из разметки), opt.refine(zip) — геокодер ответил позже 2,5 с (до 8 с), и
   * приблизительный ZIP заменён точным, если человек его не менял.
   * Таблица ZIP3 (8 КБ gzip) грузится только по нажатию и параллельно с запросом координат.
   */
  var SELF = (document.currentScript || {}).src || '';
  var z3P = null;
  function loadZ3(url) {
    if (!z3P) {
      z3P = fetch(url || SELF.replace(/ms4l-eta\.js.*$/, 'ms4l-zip3.json'))
        .then(function (r) { if (!r.ok) throw r.status; return r.json(); })
        .catch(function () { z3P = null; return null; });
    }
    return z3P;
  }
  // Ответ геокодера (или null, если заблокирован / упал / молчит 8 с) — промис late; fast — то же, но не дольше
  // 2,5 с. Опоздавший ответ не выбрасываем: им уточняется приблизительный ZIP (см. locate).
  function geocode(la, lo) {
    var ac = window.AbortController ? new AbortController() : null, t8;
    var late = new Promise(function (ok) {
      t8 = setTimeout(function () { if (ac) ac.abort(); ok(null); }, 8000);
      fetch('https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=' + la + '&longitude=' + lo +
            '&localityLanguage=en', ac ? { signal: ac.signal } : {})
        .then(function (r) { if (!r.ok) throw r.status; return r.json(); })
        .then(function (j) { clearTimeout(t8); ok(j); }, function () { clearTimeout(t8); ok(null); });
    });
    return { late: late, fast: Promise.race([late, new Promise(function (ok) { setTimeout(function () { ok(undefined); }, 2500); })]) };
  }
  // ZIP из ответа геокодера: '' — нет индекса, 'out' — не США / офшор, иначе ZIP5 из зоны модуля.
  function gzip(j) {
    var cc = j && j.countryCode, z = j ? String(j.postcode || '').replace(/\D/g, '').slice(0, 5) : '';
    if (cc && cc !== 'US') return 'out';
    var zo = z.length === 5 && zoneOf(z);
    return zo === 'out' ? 'out' : zo ? z : '';
  }
  // У самой границы координаты попадают в радиус американского ZIP3 (Виндзор в 3 км от Детройта, Тихуана —
  // от Сан-Диего), поэтому там решает часовой пояс устройства: телефон ставит его сам по месту.
  var CA_TZ = /^(Canada\/|America\/(Toronto|Montreal|Vancouver|Edmonton|Winnipeg|Halifax|Regina|St_Johns|Moncton|Whitehorse|Yellowknife|Glace_Bay|Goose_Bay|Iqaluit|Dawson|Dawson_Creek|Fort_Nelson|Creston|Swift_Current|Rankin_Inlet|Cambridge_Bay|Inuvik|Atikokan|Thunder_Bay|Nipigon|Rainy_River|Resolute|Pangnirtung)$)/;
  var MX_TZ = /^(Mexico\/|America\/(Mexico_City|Tijuana|Ensenada|Santa_Isabel|Monterrey|Matamoros|Ojinaga|Chihuahua|Ciudad_Juarez|Hermosillo|Mazatlan|Bahia_Banderas|Merida|Cancun)$)/;
  // Координаты -> { zip, out }. out: точка не входит в радиус ни одного ZIP3 (+25 км запаса) или у границы
  // стоит часовой пояс Канады/Мексики. zip — представитель ZIP3, в радиус которого точка попала (иначе ближайшего).
  function nearZip(tab, la, lo) {
    var d = tab && tab.d, c = Math.cos(la * Math.PI / 180), best = -1, bd = 1e9, hit = -1, hd = 1e9, tz = '';
    if (!d || !d.length) return null;
    for (var i = 0; i < d.length; i += 5) {
      var dy = d[i + 1] / 100 - la, dx = (d[i + 2] / 100 - lo) * c, k = Math.sqrt(dy * dy + dx * dx) * 111.2;
      if (k < bd) { bd = k; best = i; }
      if (k <= d[i + 4] + 25 && k < hd) { hd = k; hit = i; }
    }
    try { tz = Intl.DateTimeFormat().resolvedOptions().timeZone || ''; } catch (e) {}
    var j = hit < 0 ? best : hit;
    return {
      zip: ('00' + d[j]).slice(-3) + ('0' + d[j + 3]).slice(-2),
      out: hit < 0 || (la > 41.5 && CA_TZ.test(tz)) || (la < 33.5 && MX_TZ.test(tz))
    };
  }
  window.MS4L_ETA.locate = function (cb, opt) {
    opt = opt || {};
    var done = false, dog;
    function end(ok, res) { if (done) return; done = true; clearTimeout(dog); cb(ok, res); }
    if (!navigator.geolocation) return cb(false, 'unavailable');
    var tab = loadZ3(opt.zip3);
    // Соединение с геокодером греем, пока браузер спрашивает разрешение: холодное (DNS + TLS, а с 10.2026 ещё и
    // редирект на api-bdc.io) в замере съедало все 2,5 с, и ответ уходил в запасной путь.
    if (!loadZ3.warm) {
      loadZ3.warm = 1;
      ['https://api.bigdatacloud.net', 'https://api-bdc.io'].forEach(function (h) {
        var l = document.createElement('link');
        l.rel = 'preconnect'; l.href = h; l.crossOrigin = 'anonymous';
        document.head.appendChild(l);
      });
    }
    // Firefox на компьютере не зовёт ни один колбэк, если окно разрешения просто закрыть, — сторож.
    dog = setTimeout(function () { end(false, 'timeout'); }, 30000);
    navigator.geolocation.getCurrentPosition(function (pos) {
      var la = pos.coords.latitude, lo = pos.coords.longitude, g = geocode(la, lo);
      g.fast.then(function (j) {
        var z = gzip(j), cc = j && j.countryCode;
        if (z === 'out') return end(false, 'outside_us');
        if (z) return end(window.MS4L_ETA.setZip(z, 'geo'), 'ok');
        // геокодер молчит, заблокирован или не знает индекс точки — считаем сами
        tab.then(function (t) {
          var n = nearZip(t, la, lo);
          if (!n) return end(false, 'unavailable');
          if (n.out && cc !== 'US') return end(false, 'outside_us');
          end(window.MS4L_ETA.setZip(n.zip, 'geo'), 'fallback');
          // геокодер просто опоздал: точный ZIP заменяет приблизительный, если человек его ещё не трогал.
          // Меняется только текст в тех же строках, высота блока та же.
          if (j === undefined) g.late.then(function (k) {
            var x = gzip(k);
            if (x && x !== 'out' && x !== n.zip && readZip() === n.zip && window.MS4L_ETA.setZip(x, 'geo') && opt.refine) opt.refine(x);
          });
        });
      });
    }, function (err) {
      var c = err && err.code;
      end(false, c === 1 ? 'denied' : c === 3 ? 'timeout' : 'unavailable');
    }, { enableHighAccuracy: false, timeout: 10000, maximumAge: 600000 });
  };

  /* ================== строка срока под товаром в корзине ==================
   * Корзина перерисовывается аяксом, а вставленный через innerHTML <script>
   * браузер не выполняет. Поэтому разметку строки liquid не рисует — он кладёт
   * только пустой контейнер с данными позиции, а заполняет его этот файл:
   * при загрузке, по событию ms4l:eta и по любому изменению разметки.
   */
  var ICON_DAY = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" ' +
    'stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4.5" width="18" height="17" rx="2.5"/>' +
    '<path d="M8 2.5v4M16 2.5v4M3 10h18"/><path d="M9 15.5l2 2 4-4"/></svg>';
  var ICON_TRUCK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" ' +
    'stroke-linecap="round" stroke-linejoin="round"><path d="M1 4h13v12H1zM14 8h4l3 3v5h-7z"/>' +
    '<circle cx="5.5" cy="18.5" r="2"/><circle cx="17.5" cy="18.5" r="2"/></svg>';

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  function zipBtn(z) {
    return '<button type="button" class="ms4l-line__zip" data-eta-edit>' + esc(z) + '</button>';
  }
  function form() {
    return '<span class="ms4l-line__form">' +
      '<input class="ms4l-line__input" type="text" inputmode="numeric" maxlength="5" ' +
      'placeholder="ZIP code" aria-label="ZIP code" data-eta-input>' +
      '<button type="button" class="ms4l-line__go" data-eta-go>Update</button></span>';
  }

  // free — считает liquid: бесплатная доставка от $300 по заказу либо запчасти.
  function lineHTML(e, place, free, editing) {
    // Иконку цветом зоны не красим: жёлтая и голубая на белом почти не видны, а
    // зона и так названа словами в подписи.
    var ico = (e.mode === 'freight') ? ICON_TRUCK : ICON_DAY;
    var head = '<span class="ms4l-line__ico" aria-hidden="true">' + ico + '</span>';
    var body;

    // Всё одной строкой через разделители, а не блоками: строка переносится сама
    // и потому одинаково ложится и в 890px таблицы, и в 340px поп-апа. Плашка не
    // нужна — иконка слева уже отделяет блок от карточки товара.
    if (editing) {
      body = '<b>Delivery date</b>' + form();
    } else if (e.mode === 'out-of-area') {
      body = '<b>We don’t ship to ' + zipBtn(e.zip) + '</b>' +
        '<span class="ms4l-line__meta"> · contiguous US only</span>';
    } else if (e.mode === 'parts-remote') {
      body = '<b>Ships to ' + zipBtn(e.zip) + ' via FedEx</b>' +
        '<span class="ms4l-line__meta"> · cost shown at checkout</span>';
    } else if (e.mode === 'need-zip') {
      body = '<b>Delivery date</b><span class="ms4l-line__meta"> · ' +
        '<button type="button" class="ms4l-line__link" data-eta-edit>Enter ZIP code</button>' +
        ' to see the estimate</span>';
    } else {
      // Дата одна и та же для посылки и фрахта — расходятся хвостом: у фрахта
      // день привоза согласует транспортная компания, и об этом надо сказать
      // рядом с датой, иначе она прочитается как «привезут именно в этот день».
      var fr = (e.mode === 'freight');
      body = place === 'page'
        ? '<b>' + (free ? 'FREE ' : '') + (fr ? 'Freight delivery' : 'Delivery') + '</b> to ' +
            zipBtn(e.zip) + ' · as soon as <b>' + esc(e.text) + '</b>' +
            '<span class="ms4l-line__meta"> · ' + esc(e.zoneLabel) + ', ' + e.daysLo +
            ' business days' +
            (fr ? ' · freight truck: they call you to agree on the day and time' : '') + '</span>'
        // В поп-апе хвост короче: там на строку около 340px.
        : 'as soon as <b>' + esc(e.text) + '</b><span class="ms4l-line__meta">' +
            (fr ? ' · freight, by appointment' : '') + ' · ' + zipBtn(e.zip) + '</span>';
    }
    return head + '<span class="ms4l-line__t">' + body + '</span>';
  }

  var editingNode = null;
  var painting = false;
  var shownSent = {};   // «показали» шлём раз на страницу, а не на каждую позицию

  function paint() {
    if (painting) return;
    painting = true;
    var nodes = document.querySelectorAll('[data-ms4l-eta-line]');
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      var qty = parseInt(n.getAttribute('data-qty'), 10);
      var e = compute([{ type: n.getAttribute('data-type'),
                         title: n.getAttribute('data-title'),
                         qty: (isNaN(qty) || qty < 1) ? 1 : qty }]);
      var pl = n.getAttribute('data-place') || 'page';
      if (!shownSent[pl]) {
        shownSent[pl] = 1;
        track('eta_shown', { place: 'cart_' + pl, mode: e.mode || 'unknown',
                             zone: e.zoneLabel || '', zip_known: e.zip ? 1 : 0 });
      }
      var edit = (n === editingNode);
      var sig = [e.mode, e.text || '', e.zip, n.getAttribute('data-qty'), edit ? 'e' : ''].join('|');
      if (n.getAttribute('data-sig') === sig) continue;
      n.setAttribute('data-sig', sig);
      n.innerHTML = lineHTML(e, n.getAttribute('data-place') || 'page',
                             n.getAttribute('data-free') === '1', edit);
      if (edit) {
        var inp = n.querySelector('[data-eta-input]');
        if (inp) { inp.value = e.zip || ''; setTimeout(function () { inp.focus(); }, 20); }
      }
    }
    painting = false;
  }

  function submit(node) {
    var inp = node.querySelector('[data-eta-input]');
    if (!inp) return;
    if (window.MS4L_ETA.setZip(inp.value)) {
      editingNode = null;
      paint();
    } else {
      inp.classList.add('is-bad');
      setTimeout(function () { inp.classList.remove('is-bad'); }, 1200);
    }
  }

  document.addEventListener('click', function (ev) {
    var t = ev.target;
    if (!t.closest) return;
    var edit = t.closest('[data-eta-edit]');
    if (edit) {
      ev.preventDefault();
      editingNode = edit.closest('[data-ms4l-eta-line]');
      track('eta_change_click', {
        place: 'cart_' + ((editingNode && editingNode.getAttribute('data-place')) || 'page')
      });
      paint();
      return;
    }
    var go = t.closest('[data-eta-go]');
    if (go) {
      ev.preventDefault();
      var node = go.closest('[data-ms4l-eta-line]');
      if (node) submit(node);
    }
  });
  document.addEventListener('keydown', function (ev) {
    if (ev.key !== 'Enter') return;
    var t = ev.target;
    if (!t.closest || !t.matches('[data-eta-input]')) return;
    ev.preventDefault();
    var node = t.closest('[data-ms4l-eta-line]');
    if (node) submit(node);
  });

  document.addEventListener('ms4l:eta', paint);

  // Корзина и дровер перерисовываются аяксом — ловим это наблюдателем, иначе
  // после смены количества строки останутся со старой датой.
  if (window.MutationObserver) {
    var t = null;
    new MutationObserver(function () {
      if (painting) return;
      clearTimeout(t);
      t = setTimeout(paint, 80);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', paint);
  } else {
    paint();
  }

  recalc();
})();
